import type { ComponentProps } from 'react';
import { cn } from '../lib/cn';

export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden
      className={cn(
        'animate-shimmer rounded-md bg-[linear-gradient(90deg,var(--dm-surface)_0%,var(--dm-surface-elevated)_50%,var(--dm-surface)_100%)] bg-[length:200%_100%]',
        className,
      )}
      {...props}
    />
  );
}
